import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import {resolveLocaleTypeFromLanguageTag} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/functions/resolveLocaleTypeFromLanguageTag'
import {resolveLocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/functions/resolveLocaleType'

function isSupportedLocale(value: unknown): value is string {
  return typeof value === 'string' && Object.values(LocaleType).includes(value as LocaleType)
}

export function resolveGuestLocaleType(input: {
  routeLocale?: unknown
  storedLocale?: unknown
  appPlatformType: AppPlatformType
}): LocaleType {
  if(isSupportedLocale(input.routeLocale)) {
    return resolveLocaleType(input.routeLocale)
  }
  if(isSupportedLocale(input.storedLocale)) {
    return resolveLocaleType(input.storedLocale)
  }
  if(input.appPlatformType !== AppPlatformType.Web) {
    const languageTag = typeof navigator === 'undefined' ? undefined : navigator.language
    return resolveLocaleTypeFromLanguageTag(languageTag)
  }
  return LocaleType.English
}
